import React, { Component, useState, Fragment } from "react";
import Cookies from 'js-cookie'

import Header from '../cm_parts/Header.js';
import Footer from '../cm_parts/Footer.js';
import Search from "../cm_parts/Search.js";
import Board from "../cm_parts/Board.js";
import Board_2 from "../cm_parts/Board_2.js";
import CmListBody from "../cm_parts/CmListBody.js";
import HattyuuOrShipCheck from "../cm_parts/Hattyuu_or_Ship_Switch.js";
import Paste from "../cm_parts/js/Paste.js";
import PasteAdmin from "../cm_parts/js/PasteAdmin.js";
import KeppinList from "../cm_parts/js/KeppinList.js";
import Menu from "../cm_parts/Menu.js";
import CreateOrder from "../cm_parts/js/CreateOrder.js";

import {addCmListFunction} from '../cm_parts/js/CmListFunction';
import settings from '../../settings.json';


export default class CmList extends Component{
  state={
    //adamin_member:['川畑美穂','坂本　彰', '大島'],
    adamin_member:this.props.adamin_member,
    howmany_order:0,
    howmany_order_2:0,
    howmany_order_fix:0,
    howmany_order_fix_2:0,
    dataFixIdArray:[],
    cm_datas:[],
    dataArray:[],
    tonya_datas:[],
    tonya_datas_2:[],
    tonya_datas_id_fix:[],
    auth_obj:{},
    isit_hattyuu_board:false,
    table_tonya_label:'all',
    table_phase_label:'all',
    table_hattyuu_status_label:'all',
    _from:30, // DEV
    search_label:false,
    search_text:'',
    search_array:[],
    which_soart:'',
    diff_counter:0,
    tonya_no_click:false,
    formData:[],
    formDataCutHattyuu:[],
    show_cut_hattyuu_box:false,
    show_syukka_data_id_arrays:[],
    click_cut_hattyuu_box:false,
    hikiatari_id_array_fix:[],
    hikiate_zero_id_array:[],
    excel_data_import:false,
    open_menu:false,
    clickPasteHattyuuNo:false,
    isit_now_data_importing:false,
    fromToObj:{},
    hikiate_post_ids:[]
  }


  onUnload = (e) => { // the method that will be used for both add and remove event
    const confirmationMessage = 'Some message';
    e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    console.log('LEAVE');
    addCmListFunction.saveStaffInOut(this.state, 'out');
    console.log('LEAVE SAVED');
    //return confirmationMessage;   
    //alert('HELO');
  }
  
  componentDidMount () {
    let my_token = Cookies.get('_replace_token');
    if(my_token===undefined){
      window.location.href = '/login';
    }


    var url = settings.API_ENDPOINT_URL;

    const getDBData = async () => {
      //https://api.hello-remix.com/users?limit=3
      const res = await fetch(
        url + '/users/?limit=3'
      );
      const data = await res.json();
      //console.dir(data);

    };

    getDBData();

    window.addEventListener("beforeunload", this.onUnload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }



  onGetFromToObj(obj){
    this.setState({fromToObj:obj});
  }


  onSubmitCheckbox(which_type, cm_datas, dataArray){
    console.log('★ onSubmitCheckbox');
    let res_array = addCmListFunction.ChangeSelectTonya(which_type, cm_datas, this.state, dataArray);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    this.setState({tonya_no_click:false});

  }


  onChanegeSelectWithSearch(what_type, val){
    console.log('★ onChanegeSelectWithSearch');
    //let res_array = addCmListFunction.ChangeSelectTonya('select_with_seacrh', what_type, this.state, val);
    //this.setState({dataArray:res_array[0]});
  }



  onChanegeSearch(which_type, add_text, search_array){
    console.log('★ onChanegeSearch');
    console.log(which_type);
    console.log(add_text);
    if(which_type==='browser'){
      let res_array = addCmListFunction.ChangeSelectTonya('search', '', this.state, search_array);
      this.setState({dataArray:res_array[0]});
      this.setState({howmany_order:res_array[1]});
      this.setState({howmany_order_2:res_array[2]});
      this.setState({which_soart:res_array[3]});
      this.setState({diff_counter:res_array[4]});

      this.setState({search_text:'(ブラウザ)'+add_text});
    }else{
      this.setState({search_text:'(サーバー)'+add_text});
    }

    if(add_text!==undefined){
      this.setState({search_label:true});
      this.setState({search_array:search_array});
    }

    if(add_text===''){
      this.setState({tonya_no_click:false});
      this.setState({table_tonya_label:'all'});
      this.setState({table_phase_label:'all'});
      this.setState({table_hattyuu_status_label:'all'});
      this.setState({search_label:false});
    }
    //this.setState({tonya_no_click:false});

    //this.setState({table_tonya_label:'all'}); //出荷確認、問屋No.クリック、発注No毎に処理しようと検索実行すると all では チェックボックス表示されない
    //this.setState({table_phase_label:'all'});
    //this.setState({table_hattyuu_status_label:'all'});
  }


  onListDidMount(what, value){
    console.log('★ onListDidMount');
    console.log('DID MOUNT');
    console.log('what:'+what+' value:'+value);
    if(what==='search_did_mount' && value!==undefined){
      this.setState({search_label:true});
      this.setState({search_text:'(サーバー)'+value});
    }
  }


  onPasteHattyuuNo(hattyuu_no, start_index){
    console.log('★ onPasteHattyuuNo');
    this.setState({clickPasteHattyuuNo:true});
    let db_id = '';
    for (let i = start_index; i < this.state.dataArray.length; i++) {
      db_id = this.state.dataArray[i].id;
      this.state.dataArray.hattyuu_no = hattyuu_no;
      for (let i = 0; i < this.state.cm_datas.length; i++) {
        if(this.state.cm_datas[i].id===db_id){
          this.state.cm_datas[i].hattyuu_no = hattyuu_no;
          break;
        }
      }
    }
    this.setState({clickPasteHattyuuNo:false});
  }


  onIsitNowDataImporting(args){
    console.log('★ onIsitNowDataImporting');
    this.setState({isit_now_data_importing:args})
  }

  onClickMenu(args){
    console.log('★ onClickMenu');
    this.setState({open_menu:args});//
  }

  onChangeSelectTonya(args){
    console.log('★ onChangeSelectTonya');
    this.setState({howmany_order:args});// amountベース
  }
  onChangeSelectTonyaHattyuu(args, tonya_name_f, what_type){
    console.log('★ onChangeSelectTonyaHattyuu');
    this.setState({howmany_order_2:args});// howmany_hattyuu ベース

    console.log(tonya_name_f);
    let res_array = addCmListFunction.ChangeSelectTonya(what_type, 'tonya_label', this.state, tonya_name_f);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }
  }

  onChangeCmDatas(args){ // CmListBody Components didmount
    console.log('★ onChangeCmDatas');
    this.setState({cm_datas:args});
  }
  onChangeHowmanyOrderFix(args){
    console.log('★ onChangeHowmanyOrderFix');

    if(Number(args)>1){
      document.getElementById('first-loading').style.display='none'; //index.html内 読み込み中の文字を消す処理
    }

    this.setState({howmany_order_fix:args});// amountベース
  }
  onChangeHowmanyOrderFixHattyuu(args){
    console.log('★ onChangeHowmanyOrderFixHattyuu');
    this.setState({howmany_order_fix_2:args});// howmany_hattyuu ベース
  }
  onChangeDataArray(args){ // CmListBody Components didmount
    console.log('★ onChangeDataArray');
    this.setState({dataArray:args});
  }
  onChangeTonyaDatas(args){
    //console.log('★ onChangeTonyaDatas ');
    //console.dir(this.state.dataArray);
    this.setState({tonya_datas:args})
    

    // どこで順番が変わるか不明だが、ソートする dataArray
    let _dataArray = this.state.dataArray;
    _dataArray.sort((a, b) => Number(a.cm_order_no) < Number(b.cm_order_no) ? -1 : 1);
    //console.dir(_dataArray);
    this.setState({dataArray:_dataArray});
  }
  onChangeTonyaDatasIdFix(args){
    console.log('★ onChangeTonyaDatasIdFix');
    this.setState({tonya_datas_id_fix:args})
  }
  onChangeTonyaDatas2(args){
    console.log('★ onChangeTonyaDatas2');
    this.setState({tonya_datas_2:args})
  }

  onGetHikiatePostIds(ids){
    let total_ids = this.state.hikiate_post_ids.concat(ids);
    this.setState({hikiate_post_ids:total_ids});
    console.dir(total_ids);
  }

  onChangeAuthObj(args){
    console.log('★ onChangeAuthObj');
    this.setState({auth_obj:args});
  }

  onChangeBoardMode(args){
    console.log('★ onChangeBoardMode '+String(args)); // true==出荷確認
    this.setState({isit_hattyuu_board:args});
    this.setState({formDataCutHattyuu:[]});
  }

  onGetDataFixIdArray(args){
    console.log('★ onGetDataFixIdArray');
    this.setState({dataFixIdArray:args});
  }

  onGetShowSyukkaDataIdArrays(args){
    console.log('★ onGetShowSyukkaDataIdArrays');
    this.setState({show_syukka_data_id_arrays:args});
  }

  // CmListBody Components Select Elem
  onChangeSelectTonyaName(args){
    console.log('★ onChangeSelectTonyaName');
    console.log(args);
    this.setState({table_tonya_label:args});
    let res_array = addCmListFunction.ChangeSelectTonya('select-tonya', 'tonya_label', this.state, args);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});
    //console.dir(res_array);

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }
    if(args!=='all'){
      this.setState({tonya_no_click:true});
    }else{
      this.setState({tonya_no_click:false});
    }
    
  }
  onChangeSelectPhaseName(args){ // CmListBody Components didmount
    console.log('★ onChangeSelectPhaseName');
    this.setState({table_phase_label:args});
    let res_array = addCmListFunction.ChangeSelectTonya('select-phase', 'phase', this.state, args);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }
  }
  onChangeSelectGattyuuStatus(args){
    console.log('★ onChangeSelectGattyuuStatus');
    this.setState({table_hattyuu_status_label:args});
    let res_array = addCmListFunction.ChangeSelectTonya('select-my-phase', 'hattyuu', this.state, args);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }
  }


  onChangeFormData(args){
    console.log('★ onChangeFormData');
    for (let index = 0; index < args.length; index++) {
      args[index] = Number(args[index]);
    }
    this.setState({ formData:args});
  }

  onResetFormData(){
    console.log('★ onResetFormData');
    this.setState({ formData:[]});
  }

  

  // Board Components No. Button Elem
  onChangeBoardTonya(args){
    console.log('★ onChangeBoardTonya');
    console.log(args);
    this.setState({table_tonya_label:args});
    let res_array = addCmListFunction.ChangeSelectTonya('board', 'tonya_label', this.state, args);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({table_hattyuu_status_label:'未発注'});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }


    this.setState({tonya_no_click:true});
  }

  onChangeBoard_2Tonya(args){ //出荷確認 args:tonya_name_f
    console.log('★ onChangeBoard_2Tonya');
    this.setState({table_tonya_label:args});
    let res_array = addCmListFunction.ChangeSelectTonya('board_2', 'tonya_label', this.state, args);
    this.setState({dataArray:res_array[0]});
    this.setState({howmany_order:res_array[1]});
    this.setState({howmany_order_2:res_array[2]});
    this.setState({table_hattyuu_status_label:'発注済'});
    this.setState({which_soart:res_array[3]});
    this.setState({diff_counter:res_array[4]});

    if(this.state.search_array!==undefined){
      if(this.state.search_label===true && this.state.search_array.length===0){
        this.setState({search_label:false});
      }
    }

    this.setState({search_array:[]});
    this.setState({tonya_no_click:true});
    this.setState({formData:[]});
    this.setState({hikiatari_id_array_fix:[]});
    this.setState({excel_data_import:false});
  }

  onChageExcelSheet(formData, show_syukka_data_id_arrays, table_tonya_label, isit_hattyuu_board, hikiatari_id_array_fix, hikiate_zero_id_array){
    console.log('★ onChageExcelSheet');
    for (let index = 0; index < formData.length; index++) {
      formData[index] = Number(formData[index]);
    }

    this.setState({formData:formData});
    this.setState({show_syukka_data_id_arrays:show_syukka_data_id_arrays});
    this.setState({table_tonya_label:table_tonya_label});
    this.setState({isit_hattyuu_board:isit_hattyuu_board});
    this.setState({hikiatari_id_array_fix:hikiatari_id_array_fix});
    this.setState({hikiate_zero_id_array:hikiate_zero_id_array});
    this.setState({excel_data_import:true});

    console.dir(formData);
    console.dir(show_syukka_data_id_arrays);
    console.log(table_tonya_label);
    console.log(isit_hattyuu_board);
  }



  onKeepList(what, hattyuu_howmany, table_tonya_label){
    console.log('★ onKeepList');
    this.setState({howmany_order_2:hattyuu_howmany});// howmany_hattyuu ベース
    console.log(this.state.search_array);

    let _which = 1;
    if(this.state.search_array!==undefined && this.state.search_array.length>0){
      _which = 2;
      let res_array = addCmListFunction.ChangeSelectTonya('search', '', this.state, this.state.search_array);
      this.setState({dataArray:res_array[0]});
      this.setState({howmany_order:res_array[1]});
      this.setState({howmany_order_2:res_array[2]});
      this.setState({which_soart:res_array[3]});
      this.setState({diff_counter:res_array[4]});
    }else if(this.state.search_array===undefined && this.state.table_tonya_label!=='all'){
      // 発注済み、数量確認、submit後
      _which = 3;
      let res_array = addCmListFunction.ChangeSelectTonya('select-tonya', 'tonya_label', this.state, table_tonya_label);
      this.setState({dataArray:res_array[0]});
      this.setState({howmany_order:res_array[1]});
      this.setState({howmany_order_2:res_array[2]});
      this.setState({which_soart:res_array[3]});
      this.setState({diff_counter:res_array[4]});
    }

    console.log('Keep List which '+String(_which));

  }



  onChangeFormDataCutHattyuu(args){
    console.log('★ onChangeFormDataCutHattyuu');
    console.dir(args);
    this.setState({click_cut_hattyuu_box:true});
    if(args.length===0){
      this.setState({show_cut_hattyuu_box:false});
    }
    this.setState({formDataCutHattyuu:args});
    this.setState({click_cut_hattyuu_box:false});
  }


  onClickShowCutHattyuu(args){
    console.log('★ onClickShowCutHattyuu');
    this.setState({show_cut_hattyuu_box:args});
  }


  render(){
    return (
      <div className="cm-list" >

        <Header // tonya
          data={this.state}
          getTonyaDatas={this.onChangeTonyaDatas.bind(this)}
          getTonyaDatasIdFix={this.onChangeTonyaDatasIdFix.bind(this)}
          clickMenu = {this.onClickMenu.bind(this)}
          isitNowDataImporting = {this.onIsitNowDataImporting.bind(this)}
        />


        <HattyuuOrShipCheck 
          changeBordMode={this.onChangeBoardMode.bind(this)}
          data={this.state}
        />

        {this.state.isit_hattyuu_board===false && 
          <Board 
            changeTonyaLabel = {this.onChangeBoardTonya.bind(this)}
            getTonyaDatas={this.onChangeTonyaDatas.bind(this)}
            //getTonyaDatasFix = {this.onChangeTonyaDatasFix.bind(this)}
            getTonyaDatas2={this.onChangeTonyaDatas2.bind(this)}
            getDataArray={this.onChangeDataArray.bind(this)} 
            changeFormDataCutHattyuu={this.onChangeFormDataCutHattyuu.bind(this)}

            data={this.state} 
          />
        }
        {this.state.isit_hattyuu_board===true && 
          <Board_2
            data={this.state} 
            changeTonyaLabel_2 = {this.onChangeBoard_2Tonya.bind(this)}
            getTonyaDatas={this.onChangeTonyaDatas.bind(this)}
            resetFormData = {this.onResetFormData.bind(this)}
            getTonyaDatas2={this.onChangeTonyaDatas2.bind(this)}
            getHikiatePostIds = {this.onGetHikiatePostIds.bind(this)}
          />
        }


        <Search
          changeSearch={this.onChanegeSearch.bind(this)} 
          changeFormDataCutHattyuu={this.onChangeFormDataCutHattyuu.bind(this)}
          data={this.state} 
        />

        <CmListBody // cm_order
          getCmDatas={this.onChangeCmDatas.bind(this)} 
          getDataArray={this.onChangeDataArray.bind(this)} 
          getHowmanyOrderFix={this.onChangeHowmanyOrderFix.bind(this)} 
          changeSelectTonya={this.onChangeSelectTonya.bind(this)} 
          getHowmanyOrderFixHattyuu={this.onChangeHowmanyOrderFixHattyuu.bind(this)} 
          changeSelectTonyaHattyuu={this.onChangeSelectTonyaHattyuu.bind(this)} 

          getDataFixIdArray = {this.onGetDataFixIdArray.bind(this)} 
          getShowSyukkaDataIdArrays = {this.onGetShowSyukkaDataIdArrays.bind(this)}

          changeSelectTonyaName={this.onChangeSelectTonyaName.bind(this)} 
          changeSelectPhaseName={this.onChangeSelectPhaseName.bind(this)} 
          changeSelectHattyuuStatus={this.onChangeSelectGattyuuStatus.bind(this)} 
          getAuthObj = {this.onChangeAuthObj.bind(this)} 

          listDidMount = {this.onListDidMount.bind(this)}
          pasteHattyuuNo = {this.onPasteHattyuuNo.bind(this)}
          submitCheckbox = {this.onSubmitCheckbox.bind(this)}
          keepList = {this.onKeepList.bind(this)}
          changeFormData = {this.onChangeFormData.bind(this)}
          changeFormDataCutHattyuu={this.onChangeFormDataCutHattyuu.bind(this)}
          clickShowCutHattyu={this.onClickShowCutHattyuu.bind(this)}

          changeSelectWithSearch={this.onChanegeSelectWithSearch.bind(this)} 
          getFromToObj={this.onGetFromToObj.bind(this)}

          data={this.state} 
        />

        
        <Paste 
          data={this.state} 
          keepList = {this.onKeepList.bind(this)}
          changeSelectTonyaHattyuu={this.onChangeSelectTonyaHattyuu.bind(this)} 
          getCmDatas={this.onChangeCmDatas.bind(this)} 
          getDataArray={this.onChangeDataArray.bind(this)} 
          
          changeExcelSheet = {this.onChageExcelSheet.bind(this)} 
          changeTonyaLabel_2 = {this.onChangeBoard_2Tonya.bind(this)}
        />


        <CreateOrder 
          data={this.state} 
        />

        {/*
        {this.state.adamin_member.includes(this.state.auth_obj.name) ?
          <>

          </>
          : <></>
        }
        */}
        
        
        <KeppinList
          data={this.state} 
        />
        
        
        <PasteAdmin 
          data={this.state} 
          keepList = {this.onKeepList.bind(this)}
          getCmDatas={this.onChangeCmDatas.bind(this)} 
          getDataArray={this.onChangeDataArray.bind(this)} 
        />




        <Footer
          data={this.state} 
        />

        {this.state.open_menu ? 
          <>
            <Menu 
              data={this.state} 
              clickMenu = {this.onClickMenu.bind(this)}
            />
          </> : <></>

        }



      </div>
    );
  }
}

